import Axios from "@app/api/axios";
import { REPORTS, SHARE_REPORTS } from "@utils/constant";

export const shareOrderReports = (orderId,email) => {
  return Axios.post(`${REPORTS}/${orderId}/${SHARE_REPORTS}`, {email});
};
